export default function uikitMagics(Alpine) {
    Alpine.magic("getModule", () => async (moduleName, options={}) => {
        let module;
        switch(moduleName) {
            // Carousel (tiny-slider.js)
            case "carousel":
                const { tns } = await import("tiny-slider/dist/tiny-slider");
                module = tns;
                break;
            // Tooltip (tippy.js)
            case "tooltip":
                const { default: tippy } = await import("tippy.js");
                tippy.setDefaultProps(options);
                module = tippy;
                break;
            // Chart (chart.js)
            case "chart":
                const { Chart } = await import("chart.js/auto");
                const { default: helpers } = await import("./x-data/chart/helpers/generateColors");
                module = { Chart, helpers };
                break;
            // Date (date-fns.js)
            case "date":
                const dateFn = await import("date-fns");
                if (options.locale) {
                    const locales = await import("date-fns/locale");
                    options.locale = locales[options.locale] ?? locales['enUS'];
                }
                dateFn.setDefaultOptions(options);
                module = dateFn;
                break;
            default:
        }
        return module;
    });
}